import httpClient from "@/services/httpClient";
import { server } from "@/services/constants";

export const createActivity = (data) => {
  return httpClient.post(server.ACTIVITY + `/createFWeb`, data);
};
export const createActivityCheckin = (data) => {
  return httpClient.post(server.ACTIVITY + `/createCheckin`, data);
};
export const createActivityEmp = (data) => {
  return httpClient.post(server.ACTIVITY + `/createFWebEmp`, data);
};
export const updateActivity = (id, data) => {
  return httpClient.put(server.ACTIVITY + `/updateFWeb/${id}`, data);
};
export const updateActivityEdit = (id, data) => {
  return httpClient.put(server.ACTIVITY + `/updateFWebEdit/${id}`, data);
};
export const getActivityAll = () => {
  return httpClient.get(server.ACTIVITY + `/get/list`);
};
export const getActivityAllByCompany = (company_id) => {
  return httpClient.get(server.ACTIVITY + `/getByConpany/list/${company_id}`);
};
export const getAllActivityByUserID = (userid) => {
  return httpClient.get(
    server.ACTIVITY + `/getByConpany-list-by-userid/${userid}`
  );
};

export const getAllActivityByUserIDPagination = (
  page,
  limit,
  sortBy,
  sortOrder,
  user_id
) => {
  return httpClient.get(
    server.ACTIVITY + `/getByConpany-list-by-userid-pagination/${user_id}`,
    {
      params: {
        page,
        limit,
        sortBy,
        sortOrder,
      },
    }
  );
};

export const getAllActivityByUserIDPaginationV2 = (
  page,
  limit,
  sortBy,
  sortOrder,
  user_id,
  search,
  searchCharge,
  searchChargeJob,
  datefrom,
  dateto
) => {
  return httpClient.get(
    server.ACTIVITY + `/getByConpany-list-by-userid-pagination-v2/${user_id}`,
    {
      params: {
        page,
        limit,
        sortBy,
        sortOrder,
        search,
        searchCharge,
        searchChargeJob,
        datefrom,
        dateto,
        searchEmp: null,
      },
    }
  );
};

export const getAllCheckInOutByUserID = (userid, datefrom, dateto) => {
  return httpClient.get(
    server.ACTIVITY +
      `/getByConpany-checkinout-list-by-userid/${userid}/${datefrom}/${dateto}`
  );
};
export const getAllCheckInOutByDep = (query) => {
  return httpClient.get(
    server.ACTIVITY + `/getByConpany-checkinout-list-by-dep`,
    query
  );
};
export const getCheckinDateWeb = (userid) => {
  return httpClient.get(server.ACTIVITY + `/checkusercheckin/${userid}`);
};
export const getActivityByID = (id) => {
  return httpClient.get(server.ACTIVITY + `/getActivityByID/${id}`);
};
export const getAllActivityByDep = (depid) => {
  return httpClient.get(server.ACTIVITY + `/getByConpany-list-by-dep/${depid}`);
};
export const getAllActivityByDate = (query) => {
  return httpClient.get(server.ACTIVITY + `/getByConpany-list-by-date`, query);
};

export const getActivityfortimesheetreport = (query) => {
  return httpClient.get(server.ACTIVITY + `/getfortimesheetreport`, query);
};
export const getfortimesheetAttendantreport = (query) => {
  return httpClient.get(
    server.ACTIVITY + `/getfortimesheetAttendantreport`,
    query
  );
};

export const getActivityforemployeesummaryreport = (query) => {
  return httpClient.get(
    server.ACTIVITY + `/getforemployeesummaryreport`,
    query
  );
};

export const getActivityforclientsummaryreport = (query) => {
  return httpClient.get(server.ACTIVITY + `/getforclientsummaryreport`, query);
};

export const getActivityattendantreport = (query) => {
  return httpClient.get(server.ACTIVITY + `/getattendantreport`, query);
};

export const getcheckattendantuserid = (query) => {
  return httpClient.get(server.ACTIVITY + `/checkattendantuserid`, query);
};

export const getdataReportSumAct = (query) => {
  return httpClient.get(
    server.ACTIVITY + `/summary-timesheets-activity-report`,
    query
  );
};

export const getdataReportSumActPagination = (
  page,
  limit,
  sortBy,
  sortOrder,
  datefrom,
  dateto,
  department = 0,
  employee_id = 0
) => {
  return httpClient.get(
    server.ACTIVITY + `/summary-timesheets-activity-report-pagination`,
    {
      params: {
        page,
        limit,
        sortBy,
        sortOrder,
        datefrom,
        dateto,
        department,
        employee_id,
      },
    }
  );
};

export const deleteActivity = (id) => {
  return httpClient.delete(server.ACTIVITY + `/${id}`);
};

export const getAllActivityByDatePagination = (
  page,
  limit,
  sortBy,
  sortOrder,
  dateform,
  dateto,
  userId,
  departmentId,
  customerId,
  jobTitleId,
  caseType,
  chargeType
) => {
  return httpClient.get(
    server.ACTIVITY + `/getByConpany-list-by-date-pagination`,
    {
      params: {
        page,
        limit,
        sortBy,
        sortOrder,
        dateform,
        dateto,
        userId,
        departmentId,
        customerId,
        jobTitleId,
        caseType,
        chargeType,
      },
    }
  );
};
